import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress harmless ResizeObserver errors
const resizeObserverLoopErr = /ResizeObserver loop/i;
const originalError = console.error;
const originalWarn = console.warn;

// Suppress console errors
console.error = (...args) => {
  const firstArg = args[0];
  if (
    (typeof firstArg === 'string' && resizeObserverLoopErr.test(firstArg)) ||
    (firstArg instanceof Error && resizeObserverLoopErr.test(firstArg.message))
  ) {
    return;
  }
  originalError.call(console, ...args);
};

// Suppress console warnings
console.warn = (...args) => {
  const firstArg = args[0];
  if (typeof firstArg === 'string' && resizeObserverLoopErr.test(firstArg)) {
    return;
  }
  originalWarn.call(console, ...args);
};

// Suppress at window level
window.addEventListener('error', (e) => {
  if (e.message && resizeObserverLoopErr.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

// Suppress unhandled rejections
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && resizeObserverLoopErr.test(e.reason.message)) {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
